module.exports = __webpack_public_path__ + "img/Im7.11441680.png";